import { AutomakerLogo, AutomakerLogoPortal } from '~/common/components';
import { usePurchaseContext } from '~/purchase/context';

export default function SelectedAutomakerLogo() {
  const { state } = usePurchaseContext();
  const automakerLogo =
    state.targetCustomer?.matchedTheme?.automakerLogo?.resourcesFormat?.at(
      0,
    )?.url;
  if (!automakerLogo) {
    return null;
  }
  return (
    <AutomakerLogoPortal>
      <AutomakerLogo src={automakerLogo} />
    </AutomakerLogoPortal>
  );
}
